<template>
  <div class="base-info">
    <div v-if="detailInfo">
      <Form class="content-wrapper-430" :label-width="120">
        <Row>
          <FormItem label="学校:" style="width: 50%"
            >{{ detailInfo.schoolName }}
          </FormItem>
          <FormItem label="机构:" style="width: 50%"
            >{{ detailInfo.orgName }}
          </FormItem>
        </Row>
        <Row>
          <FormItem label="协议模板:" style="width: 50%"
            >{{ detailInfo.templateFileName }}
          </FormItem>
          <FormItem label="学期:" style="width: 50%"
            >{{ detailInfo.yearTermName }}
          </FormItem>
        </Row>
      </Form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'baseInfo',
  props: {
    detailInfo: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.base-info {
  border-bottom: 1px solid #eee;
  margin-bottom: 12px;
}
</style>